export default function(x) {
  return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
}


//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/e1fn.js
// module id = 149
// module chunks = 0